import format from 'date-fns/format';

export const TYPE_LABELS = {
  image: 'Imagem',
  video: 'Vídeo',
  carousel_album: 'Carrossel',
  reel: 'Reel',
  story: 'Story',
};

export const TYPE_COLORS = {
  image: 'bg-n-blue-9',
  video: 'bg-n-violet-9',
  carousel_album: 'bg-n-amber-9',
  reel: 'bg-n-teal-9',
  story: 'bg-n-pink-9',
};

export function formatDate(dateStr) {
  try {
    return format(new Date(dateStr), 'dd/MM');
  } catch {
    return dateStr;
  }
}

export function sentimentClass(sentiment) {
  if (sentiment === 'positive') return 'bg-n-teal-9';
  if (sentiment === 'negative') return 'bg-n-ruby-9';
  return 'bg-n-slate-9';
}

export function riskClass(risk) {
  if (risk === 'low') return 'bg-n-slate-9';
  if (risk === 'medium') return 'bg-n-amber-9';
  if (risk === 'high') return 'bg-n-orange-9';
  if (risk === 'critical') return 'bg-n-ruby-9';
  return 'bg-n-slate-9';
}

export function profileTypeClass(profileType) {
  if (profileType === 'leadership') return 'bg-n-blue-9';
  if (profileType === 'adversary') return 'bg-n-ruby-9';
  if (profileType === 'listening') return 'bg-n-violet-9';
  return 'bg-n-slate-9';
}

export function platformClass(platform) {
  if (platform === 'instagram') return 'bg-n-pink-9';
  if (platform === 'facebook') return 'bg-n-blue-9';
  if (platform === 'web') return 'bg-n-slate-9';
  return 'bg-n-slate-9';
}
